<!-- <app-survay-header></app-survay-header> -->
<div class="Main-Cont">
    <div class="text-center">
        <div>
            <img src="../../../../../assets/image/m@2x.png" alt="" />
        </div>
        <div class="text-dark fw-bold fs-5 survey-head">
            Please wait for a few 
            seconds,we are taking to you 
            the main survey page
        </div>
        <div class="survey-head">
            <img class="Image-Section" src="../../../../../assets/image/artboard-1@2x.png" alt="" />
        </div>
    </div>
</div>
